import React from "react";
import standardInputWrapper from "../../standard-input-wrapper/standard-input";
import CommonFormInput from "../../../common/form/input/common-form-input";

const SCAT5InputCommon = standardInputWrapper(CommonFormInput);

export default SCAT5InputCommon;
